import Header from "../Global/Header";
import Breadcrumb from "../Global/Breadcrumb";
import Servicesec from "../Mainabout/Servicesec";
import Service from "../Mainabout/Service";
import Whychooseus from "../Mainabout/Whychooseus";
import Aboutus from "../Mainabout/Aboutus";
import Text from "../Mainabout/Text";
import Expert from "../Mainabout/Expert";
import Downloadsec from "../Global/Downloadsec";
import Faq from "../Mainabout/Faq";
import Callto from "../Global/Callto";
import Footer from "../Global/Footer";
import Gototop from "../Global/Gototop";

const Main = () => {
  return (
    <>
      <Header />
      <Breadcrumb Title="About Us" Subtitle="About Us" />
      <div className="page_wrapper">
        <Servicesec />
        <Whychooseus />
        <Aboutus />
        <Service />
        <Text />
        <Expert />
        <Downloadsec />
        <Faq />
        <Callto />
        <Footer />
        <Gototop />
      </div>
    </>
  );
};

export default Main;
